import { Box, Button, Dialog, DialogContent, DialogTitle, FormControl, IconButton, InputLabel, MenuItem, Select, TextField, Tooltip, Typography } from '@mui/material'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { hours } from '../hours'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch } from 'react-redux';
import { copyPair, deleteEventPair, movePair } from 'src/redux/actions/Scheduler';
import DriveFileMoveOutlinedIcon from '@mui/icons-material/DriveFileMoveOutlined';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useSelector } from 'react-redux';

const EventDetailsDialog = ({open, onClose, eventStart, eventStop, onEditEvent, socketRef}) => {
    const { t } = useTranslation()
    const dispatch = useDispatch()

    const {schedulers} = useSelector((state) => state.Scheduler)

    const daysWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    const [deleteMode, setDeleteMode] = useState(false)

    const syncScreensByMac = async (macs) => {
        console.log("Syncing screens with MACs:", macs);
        try {
            for await (const screen of macs) {
                await socketRef?.current?.emit("sync", { detail: { mac: screen } })
                console.log("Sync command sent to screen with MAC:", screen);
            }
        } catch (error) {
            console.error("Failed to sync screens by MAC:", error);
        }
    }

    const handleEventDelete = async () => {
        const screensAttachedToScheduler = await dispatch(deleteEventPair(eventStart?.pair, eventStart?.group))
        await syncScreensByMac(screensAttachedToScheduler.map(s => s.mac))
        resetAndClose()
    }

    const resetAndClose = () => {
        setDeleteMode(false)
        setDeleteInput('')
        setMoveCopy('')
        setMoveCopyScheduler('')
        onClose()
    }

    const handleEventPairMoveCopy = () => {
        if (moveCopyScheduler) {
            if(moveCopy == 'move') {
                dispatch(movePair(eventStart?.pair, moveCopyScheduler, eventStart.group))
                resetAndClose()
            }else {
                dispatch(copyPair(eventStart?.pair, moveCopyScheduler))
                resetAndClose()
            }
        }
    }

    const [deleteInput, setDeleteInput] = useState('')
    const [moveCopy, setMoveCopy] = useState('')
    const [moveCopyScheduler, setMoveCopyScheduler] = useState('')

    const ParsedTimestamp = () => {
        const timestamp = eventStart.when
        if(timestamp.includes('WWW') && timestamp.includes('MMM') && timestamp.includes('DD') && timestamp.includes('RRRR') && !timestamp.includes('**:**:**')) {
            return (
                <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column"
                }}>
                    <Typography variant="button" textAlign="center">{t("views.scheduler.everyDay")}:</Typography>
                    <Box sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "20px",
                        mt: 1
                    }}>
                        <Typography variant='h5' textAlign="center">{eventStart.when.split(' ')[4].slice(0, 5)}</Typography>
                        <ArrowForwardIcon />  
                        <Typography variant='h5' textAlign="center">{eventStop.when.split(' ')[4].slice(0, 5)}</Typography>
                    </Box>
                </Box>
            )
        }
        if(!timestamp.includes('WWW') && timestamp.includes('MMM') && timestamp.includes('DD') && timestamp.includes('RRRR') && !timestamp.includes('**:**:**')) {
            return (
                <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column"
                }}>
                    <Typography variant="button" textAlign="center">{t("views.scheduler.everyWeek")}:</Typography>
                    <Box sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "20px",
                        mt: 2
                    }}>
                        <Box sx={{
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",
                            gap: "10px"
                        }}>
                            <Typography variant='h6'>{daysWeek.find(dw => dw.includes(timestamp.split(' ')[0]))}</Typography>
                            <Typography variant='h5' textAlign="center">{timestamp.split(' ')[4].slice(0, 5)}</Typography>
                        </Box>
                        <ArrowForwardIcon />  
                        <Box sx={{
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",
                            gap: "10px"
                        }}>
                            <Typography variant='h6'>{daysWeek.find(dw => dw.includes(eventStop.when.split(' ')[0]))}</Typography>
                            <Typography variant='h5' textAlign="center">{eventStop.when.split(' ')[4].slice(0, 5)}</Typography>
                        </Box>
                    </Box>
                </Box>
            )
        }
        if(timestamp.includes('WWW') && timestamp.includes('MMM') && !timestamp.includes('DD') && timestamp.includes('RRRR') && !timestamp.includes('**:**:**')) {
            return (
                <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column"
                }}>
                    <Typography variant="button" textAlign="center">{t("views.scheduler.everyMonth")}:</Typography>
                    <Box sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "20px",
                        mt: 2
                    }}>
                        <Box sx={{
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",
                            gap: "10px"
                        }}>
                            <Typography variant='h6'>{timestamp.split(' ')[2]}{timestamp.split(' ')[2] == '01' ? 'st' : timestamp.split(' ')[2] == '01' ? 'nd' : timestamp.split(' ')[2] == '03' ? 'rd' : 'th'}</Typography>
                            <Typography variant='h5' textAlign="center">{timestamp.split(' ')[4].slice(0, 5)}</Typography>
                        </Box>
                        <ArrowForwardIcon />  
                        <Box sx={{
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",
                            gap: "10px"
                        }}>
                            <Typography variant='h6'>{eventStop.when.split(' ')[2]}{eventStop.when.split(' ')[2] == '01' ? 'st' : eventStop.when.split(' ')[2] == '01' ? 'nd' : eventStop.when.split(' ')[2] == '03' ? 'rd' : 'th'}</Typography>
                            <Typography variant='h5' textAlign="center">{eventStop.when.split(' ')[4].slice(0, 5)}</Typography>
                        </Box>
                    </Box>
                </Box>
            )
        }
        if(timestamp.includes('WWW') && !timestamp.includes('MMM') && !timestamp.includes('DD') && timestamp.includes('RRRR') && !timestamp.includes('**:**:**')){
            return (
                // <Box sx={{
                //     display: "flex",
                //     alignItems: "center",
                //     flexDirection: "column"
                // }}>
                //     <Box sx={{
                //         display: "flex",
                //         alignItems: "baseline",
                //         justifyContent: "center"
                //     }}>
                //         <Typography variant="subtitle2">{t("views.scheduler.everyYearIn")}: </Typography>
                //         <Typography variant='button'>{months.find(m => m.includes(timestamp.split(' ')[1]))}</Typography>
                //         <Typography variant="subtitle2">{t("views.scheduler.on")} </Typography>
                //         <Typography variant='button'>{timestamp.split(' ')[2]}{timestamp.split(' ')[2] == '01' ? 'st' : timestamp.split(' ')[2] == '01' ? 'nd' : timestamp.split(' ')[2] == '03' ? 'rd' : 'th'}</Typography>
                //     </Box>
                //     <Typography variant='h5' textAlign="center">{hours.find(h => h.value == timestamp.split(' ')[4].slice(null, -3))?.text}</Typography>
                // </Box>
                <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column"
                }}>
                    <Typography variant="button" textAlign="center">{t("views.scheduler.everyYear")}:</Typography>
                    <Box sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "20px",
                        mt: 2
                    }}>
                        <Box sx={{
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",
                            gap: "10px"
                        }}>
                            <Typography variant='h6'>{months.find(m => m.includes(timestamp.split(' ')[1]))} {timestamp.split(' ')[2]}{timestamp.split(' ')[2] == '01' ? 'st' : timestamp.split(' ')[2] == '01' ? 'nd' : timestamp.split(' ')[2] == '03' ? 'rd' : 'th'}</Typography>
                            <Typography variant='h5' textAlign="center">{timestamp.split(' ')[4].slice(0, 5)}</Typography>
                        </Box>
                        <ArrowForwardIcon />  
                        <Box sx={{
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",
                            gap: "10px"
                        }}>
                            <Typography variant='h6'>{months.find(m => m.includes(eventStop.when.split(' ')[1]))} {eventStop.when.split(' ')[2]}{eventStop.when.split(' ')[2] == '01' ? 'st' : eventStop.when.split(' ')[2] == '01' ? 'nd' : eventStop.when.split(' ')[2] == '03' ? 'rd' : 'th'}</Typography>
                            <Typography variant='h5' textAlign="center">{eventStop.when.split(' ')[4].slice(0, 5)}</Typography>
                        </Box>
                    </Box>
                </Box>
            )
        }
        if (timestamp.includes('WWW') && !timestamp.includes('MMM') && !timestamp.includes('DD') && !timestamp.includes('RRRR') && !timestamp.includes('**:**:**')){
            return (
                // <Box sx={{
                //     display: "flex",
                //     alignItems: "center",
                //     flexDirection: "column"
                // }}>
                //     <Box sx={{
                //         display: "flex",
                //         alignItems: "baseline",
                //         justifyContent: "center"
                //     }}>
                //         <Typography variant="subtitle2">{t("views.scheduler.everyYearIn")}: </Typography>
                //         <Typography variant='button'>{months.find(m => m.includes(timestamp.split(' ')[1]))}</Typography>
                //         <Typography variant="subtitle2">{t("views.scheduler.on")} </Typography>
                //         <Typography variant='button'>{timestamp.split(' ')[2]}{timestamp.split(' ')[2] == '01' ? 'st' : timestamp.split(' ')[2] == '01' ? 'nd' : timestamp.split(' ')[2] == '03' ? 'rd' : 'th'}</Typography>
                //     </Box>
                //     <Typography variant='h5' textAlign="center">{hours.find(h => h.value == timestamp.split(' ')[4].slice(null, -3))?.text}</Typography>
                // </Box>
                <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column"
                }}>
                    <Typography variant="button" textAlign="center">{t("views.scheduler.once")}:</Typography>
                    <Box sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "20px",
                        mt: 2
                    }}>
                        <Box sx={{
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",
                            gap: "10px"
                        }}>
                            <Typography variant='h6'>{months.find(m => m.includes(timestamp.split(' ')[1]))} {timestamp.split(' ')[2]}{timestamp.split(' ')[2] == '01' ? 'st' : timestamp.split(' ')[2] == '01' ? 'nd' : timestamp.split(' ')[2] == '03' ? 'rd' : 'th'} {timestamp.split(' ')[3]}</Typography>
                            <Typography variant='h5' textAlign="center">{timestamp.split(' ')[4].slice(0, 5)}</Typography>
                        </Box>
                        <ArrowForwardIcon />  
                        <Box sx={{
                            display: "flex",
                            alignItems: "center",
                            flexDirection: "column",
                            gap: "10px"
                        }}>
                            <Typography variant='h6'>{months.find(m => m.includes(eventStop.when.split(' ')[1]))} {eventStop.when.split(' ')[2]}{eventStop.when.split(' ')[2] == '01' ? 'st' : eventStop.when.split(' ')[2] == '01' ? 'nd' : eventStop.when.split(' ')[2] == '03' ? 'rd' : 'th'} {eventStop.when.split(' ')[3]}</Typography>
                            <Typography variant='h5' textAlign="center">{eventStop.when.split(' ')[4].slice(0, 5)}</Typography>
                        </Box>
                    </Box>
                </Box>
            )
        }
    }

    return (
        <Dialog fullWidth maxWidth="sm" open={open} onClose={resetAndClose}>
            <Box sx={{
                display: 'flex',
                justifyContent: "space-between",
                alignItems: "center",
                px: 2
            }}>
                <div style={{width: "40px"}}></div>
                <DialogTitle mt={2} textAlign="center">{t("views.scheduler.eventDetails")}</DialogTitle>
                <IconButton onClick={resetAndClose}>
                    <CloseIcon />
                </IconButton>
            </Box>
            <DialogContent sx={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
                alignItems: "center",
                mb: 2
            }}>
                <ParsedTimestamp />
                <Box sx={{
                    display: "flex",
                    justifyContent: "center",
                }}>
                    <Typography variant="subtitle1" textAlign="center"><span style={{opacity: '0.5'}}>{t("views.scheduler.object")}: </span>&nbsp;</Typography>
                    <Tooltip title={eventStart?.playlist?.playlistName?.length > 30 ? eventStart?.playlist?.playlistName : ''}>
                        <Typography variant="subtitle1">{eventStart?.playlist?.playlistName?.length > 30 ? eventStart?.playlist?.playlistName?.slice(0, 30) : eventStart?.playlist?.playlistName}</Typography>
                    </Tooltip>
                </Box>
                {!moveCopy && (
                    <Box sx={{
                        display: "flex",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: "20px"
                    }}>
                        {deleteMode ? (
                            <>
                                <IconButton onClick={() => {
                                    setDeleteMode(false)
                                    setDeleteInput('')
                                }}>
                                    <CloseIcon />
                                </IconButton>
                                <TextField id='confirmDeleteInput' autoComplete="off" label={t("views.scheduler.typeDelete")} variant="outlined" size="small" onInput={(e) => setDeleteInput(e.target.value)} value={deleteInput} />
                                <Button variant='contained' color='error' disabled={deleteInput.toLowerCase() == 'delete' ? false : true} onClick={handleEventDelete} size="small">{t("views.scheduler.deleteEventConfirm")}</Button>
                            </>
                        ) : (
                            <>
                                <Button variant='contained' color='primary' onClick={() => {
                                    onEditEvent(eventStart?.pair)
                                    resetAndClose()
                                }} size="small">{t("views.scheduler.edit")}</Button>
                                <Button variant='contained' color='error' onClick={() => setDeleteMode(true)} size="small">{t("views.scheduler.delete")}</Button>
                            </>
                        )}
                    </Box>
                )}
                <Box sx={{
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    gap: "20px"
                }}>
                    {moveCopy ? (
                        <>
                            <IconButton onClick={() => {
                                setMoveCopyScheduler('')
                                setMoveCopy('')
                            }}>
                                <CloseIcon />
                            </IconButton>
                            <FormControl size="small" sx={{minWidth: 200}}>
                                <InputLabel id="selectSchedulerMoveCopyLabel">Choose scheduler</InputLabel>
                                <Select
                                    labelId="selectSchedulerMoveCopyLabel"
                                    id="selectSchedulerMoveCopy"
                                    value={moveCopyScheduler}
                                    label="Choose scheduler"
                                    onChange={(e) => setMoveCopyScheduler(e.target.value)}
                                >
                                    <MenuItem value="">
                                        {/* <em>- Select -</em> */}
                                    </MenuItem>
                                    {schedulers.filter(sch => sch._id !== eventStart.group).map(sch => {
                                        return (
                                            <MenuItem value={sch._id} key={sch._id}>{sch.name}</MenuItem>
                                        )
                                    })}
                                </Select>
                            </FormControl>
                            <Button variant='contained' size='sm' onClick={handleEventPairMoveCopy}>{moveCopy == 'copy' ? 'Copy' : "Move"}</Button>
                        </>
                    ) : (
                        <>
                            <Button endIcon={<DriveFileMoveOutlinedIcon />} onClick={() => setMoveCopy('move')}>Move</Button>
                            <Button endIcon={<ContentCopyIcon />} onClick={() => setMoveCopy('copy')}>Copy</Button>
                        </>
                    )}
                </Box>
            </DialogContent>
        </Dialog>
    )
}

export default EventDetailsDialog
